export default __webpack_public_path__ + "static/media/amazonclone.499fbc16.PNG";